import angular from 'angular';
import { PricingFormController } from './form-pricing.controller';

export const PricingForm = {
  selector: 'formPricing',
  controller: PricingFormController,
  bindings: {
    exit: '&',
    show: '=',
    vehicle: '<',
    dummyVehicle: '=?',
  },
  template: /* html */ `
    <form class="default-form backdrop-overlay-form pricing-form" ng-submit="$ctrl.formTransmission()" ng-if="$ctrl.show">
      <div class="box-wrap">
        <div class="boxL">
          <div class="intro">
            <h2>Fahrzeugpreise</h2>
          </div>

          <vehicle-pricing-form [price]="$ctrl.updateData.price" [costs]="$ctrl.updateData.costs"></vehicle-pricing-form>

          <div class="btn-wrap right">
            <button type="submit" class="btn-lvl1" ng-class="{'btn-sending': $ctrl.sending}" ng-disabled="$ctrl.sending">Daten speichern</button>
          </div>
        </div>
      </div>
    </form>
  `,
};

export default angular.module('directives.formPricing', [])
  .component(PricingForm.selector, PricingForm)
  .name;
